import { GallerySceneType } from '../CommonTypes';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';

export const fetchGalleryScenes = async (company: string, siteId: string) => {
  if (process.env.NODE_ENV === 'development') console.log('fetching gallery', siteId, company);

  const colRef = query(collection(db, `${company}/${siteId}/scenes`), orderBy('order'));

  const results = await getDocs(colRef);

  return results.docs.map(doc => {
    const data = doc.data() as Omit<GallerySceneType, 'sceneid'>;

    return { ...data } as GallerySceneType;
  });
};
